<div class="card">
  <div class="flex">
    <div class="ml-0">
      {{'common.from' | transloco}}:
      <p-calendar
        [(ngModel)]="fromDate"
        [firstDayOfWeek]="1"
        [showIcon]="true"
        [readonlyInput]="false"
        class="ml-2"
        dateFormat="dd/mm/yy"
      ></p-calendar>
    </div>
    <div class="ml-2">
      <p-button [label]="'common.search' | transloco" (onClick)="loadStatistics()"></p-button>
    </div>
  </div>
</div>

<div class="grid">
  <div class="col-12 xl:col-6">
    <div class="card main-height" *ngIf="!loadingStatistics && tenantStatistics">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.statistics.totalDevicesWithData' | transloco}}</h4></div>
      <hr>
      <app-generic-graph
        *ngIf="devicesGraphData"
        [data]="devicesGraphData"
        [plotOptions]="plotOptions"
        [customSeries]="true"
        [legend]="true"
        height="200"
        name="Value"
        chartType="pie"
      ></app-generic-graph>
      <p class="text-center bold with-data-percentage">
        {{(totalDevicesWithData / totalDevices) * 100 | number: '.2-2'}}%
      </p>
    </div>
    <div class="card main-height" *ngIf="loadingStatistics || !tenantStatistics">
      <p-skeleton height="32px"></p-skeleton>
      <hr>
      <p-skeleton height="248px"></p-skeleton>
    </div>
  </div>
  <div class="col-12 xl:col-6">
    <div class="card main-height" *ngIf="!loadingStatistics && tenantStatistics">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.statistics.totalSignalsWithData' | transloco}}</h4></div>
      <hr>
      <app-generic-graph
        *ngIf="signalsGraphData"
        [data]="signalsGraphData"
        [plotOptions]="plotOptions"
        [customSeries]="true"
        [legend]="true"
        height="200"
        name="Value"
        chartType="pie"
      ></app-generic-graph>
      <p class="text-center bold with-data-percentage">
        {{(totalSignalsWithData / totalSignals) * 100 | number: '.2-2'}}%
      </p>
    </div>
    <div class="card main-height" *ngIf="loadingStatistics || !tenantStatistics">
      <p-skeleton height="32px"></p-skeleton>
      <hr>
      <p-skeleton height="248px"></p-skeleton>
    </div>
  </div>
</div>

<div class="card mb-3 mt-2">
  <div class="flex flex-column sm:flex-row">
    <div>
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        [(ngModel)]="searchOptions.tenant"
        [placeholder]="'search.byTenant' | transloco"
        pInputText
        type="text"
      />
    </span>
    </div>
    <div class="mt-2 sm:mt-0 sm:ml-3" *ngIf="sortOptions">
      <p-dropdown
        [(ngModel)]="searchOptions.sortBy"
        [placeholder]="'common.orderBy' | transloco"
        [options]="sortOptions"
        styleClass="inline-dropdown w-full sm:w-auto"
        class="w-full sm:w-auto"
        optionLabel="label"
        optionValue="id"
      ></p-dropdown>
      <button
        [icon]="'pi pi-sort-amount-' + (searchOptions.sortOrder === 0 ? 'down' : 'up')"
        (click)="searchOptions.sortOrder = (searchOptions.sortOrder === 0 ?  1 : 0)"
        pButton
        pRipple
      ></button>
    </div>
  </div>
</div>

<div class="grid" *ngIf="!loadingStatistics && tenantStatistics">
  <div class="xl:col-2 lg:col-3 md:col-4 sm:col-6 col-12" *ngFor="let tenant of filteredTenants">
    <div class="card main-height">
      <div class="pt-1 text-center w-100">
        <h5 class="mb-1">{{tenant.name}}</h5>
      </div>
      <hr>
      <table class="details-table text-center w-full">
        <tr>
          <td class="p-0">
            <p class="m-0 bold">{{'model.devices' | transloco}}</p>
            <p style="font-size: 10px">{{'misc.statistics.totalDevicesWithData' | transloco}}</p>
          </td>
        </tr>
        <tr>
          <td class="p-0 bold" [style.font-size]="'28px'">
            <p class="inline" *ngIf="tenant.devicesWithData <= 0" style="color: #D91E1E;">{{tenant.devicesWithData}}</p>
            <p class="inline" *ngIf="tenant.devicesWithData > 0" style="color: #039FE4;">{{tenant.devicesWithData}}</p>
            <p class="inline"> / {{tenant.devices}}</p>
          </td>
        </tr>
        <tr>
          <td class="p-0 bold" [style.font-size]="'16px'">
            <p class="inline" *ngIf="tenant.percentageDevicesWithData <= 0" style="color: #D91E1E">
              {{(tenant.percentageDevicesWithData * 100).toFixed(2)}}%
            </p>
            <p class="inline" *ngIf="tenant.percentageDevicesWithData > 0" style="color: #039FE4;">
              {{(tenant.percentageDevicesWithData * 100).toFixed(2)}}%
            </p>
          </td>
        </tr>
        <tr>
          <td class="p-0" style="height: 10px"></td>
        </tr>
        <tr>
          <td class="p-0">
            <p class="m-0 bold">{{'model.signals' | transloco}}</p>
            <p style="font-size: 10px">{{'misc.statistics.totalSignalsWithData' | transloco}}</p>
          </td>
        </tr>
        <tr>
          <td class="p-0 bold" [style.font-size]="'28px'">
            <p class="inline" *ngIf="tenant.signalsWithData <= 0" style="color: #D91E1E;">{{tenant.signalsWithData}}</p>
            <p class="inline" *ngIf="tenant.signalsWithData > 0" style="color: #039FE4;">{{tenant.signalsWithData}}</p>
            <p class="inline"> / {{tenant.signals}}</p>
          </td>
        </tr>
        <tr>
          <td class="p-0 bold" [style.font-size]="'16px'">
            <p class="inline" *ngIf="tenant.percentageSignalsWithData <= 0" style="color: #D91E1E;">
              {{(tenant.percentageSignalsWithData * 100).toFixed(2)}}%
            </p>
            <p class="inline" *ngIf="tenant.percentageSignalsWithData > 0" style="color: #039FE4;">
              {{(tenant.percentageSignalsWithData * 100).toFixed(2)}}%
            </p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
